import React from "react"
class AnswerFeedback extends React.Component {
  answerFeedbackClassNames() {
    return this.props.didAnswerCorrectly
      ? 'answer-feedback correct'
      : 'answer-feedback';
  }

  render() {
    return (
      <span className={this.answerFeedbackClassNames()}>
        {this.props.didAnswerCorrectly
          ? String.fromCharCode(10004) // '&#x2714;'
          : String.fromCharCode(10008) // '&#x2718;'
        }
      </span>
    );
  }
}
export default AnswerFeedback
